module.exports = __webpack_public_path__ + "static/img/home_cpjfw_znsb.7c09788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_cpjfw_znsb.png
// module id = nfT/
// module chunks = 21